module.exports = __webpack_public_path__ + "static/media/ic-notif-new-obligation.b223bf0a.svg";